import { render, staticRenderFns } from "./ExtraPaymentDiscountList.vue?vue&type=template&id=d13b3ff2&"
import script from "./ExtraPaymentDiscountList.vue?vue&type=script&lang=js&"
export * from "./ExtraPaymentDiscountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports